import React, { useEffect, useRef } from "react";

declare global {
    interface Window {
        Trustpilot?: {
            loadFromElement: (element: Element, options?: unknown, callback?: unknown) => void;
        };
    }
}

type TrustPilotScoreProps = {
    locale?: string;
    templateId?: string;
    businessUnitId?: string;
    styleWidth?: string;
    reviewLink?: string;
};

const TRUSTPILOT_SCRIPT_ID = "trustpilot-widget-bootstrap";
const TRUSTPILOT_SCRIPT_SRC = "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";

export function TrustPilotScore({
    locale = "en-US",
    templateId = "53aa8807dec7e10d38f59f32",
    businessUnitId = "5ced60ecfeac9d0001b63194",
    reviewLink = "https://www.trustpilot.com/review/aaalife.com",
    styleWidth = "160px",
}: TrustPilotScoreProps) {
    const containerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        function renderWidget() {
            if (window.Trustpilot && containerRef.current) {
                window.Trustpilot.loadFromElement(containerRef.current);
            }
        }

        const existing = document.getElementById(TRUSTPILOT_SCRIPT_ID) as HTMLScriptElement | null;
        if (existing) {
            renderWidget();
            return;
        }

        const script = document.createElement("script");
        script.id = TRUSTPILOT_SCRIPT_ID;
        script.src = TRUSTPILOT_SCRIPT_SRC;
        script.async = true;
        script.onload = renderWidget;
        document.body.appendChild(script);
    }, []);

    return (
        <div
            ref={containerRef}
            className="trustpilot-widget bg-transparent"
            data-locale={locale}
            data-template-id={templateId}
            data-businessunit-id={businessUnitId}
            data-theme="dark"
            data-style-width={styleWidth}
        >
            <a href={reviewLink} target="_blank" rel="noopener noreferrer">
                Trustpilot
            </a>
        </div>
    );
}

export default TrustPilotScore;
